import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./custom.scss";
import { App } from "./App";
import * as serviceWorker from "./serviceWorker";

import "./i18n";

// Using ReactDOM.render (legacy mode) because react-router-dom v5 is not
// compatible with createRoot (concurrent mode). Migrate to React Router v6
// before switching to createRoot.
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
